import React, { FunctionComponent, MouseEventHandler } from 'react';
import type { OperatingCompanyProps } from './types';
import classnames from 'classnames';

type Props = OperatingCompanyProps & {
  isHeroActive: boolean;
  infoRef: React.RefObject<HTMLDivElement>;
  onClickScroll: MouseEventHandler<HTMLAnchorElement>;
};

export const Presentation: FunctionComponent<Props> = ({
  heroLogo,
  service1Image,
  service2Image,
  service3Image,
  news1Image,
  news2Image,
  news3Image,
  news4Image,
  rootUrl,
  contactIndexUrl,
  isHeroActive,
  infoRef,
  onClickScroll,
}) => {
  return (
    <main className="l-wrap l-wrap-old">
      {/* SP hero */}
      <section className="company-hero company-hero-sp">
        <div className="company-hero-container">
          <div className={classnames('company-hero-logo', { 'is-active': isHeroActive })}>
            <img
              src={heroLogo}
              width="120"
              height="50"
              alt="READY TO FASHION"
            />
          </div>
        </div>
      </section>

      {/* PC hero */}
      <section className="company-hero company-hero-pc">
        <div className="company-hero-container">
          <h3
            className={classnames('company-hero-heading', {
              'is-active': isHeroActive,
            })}
          >
            ファッションは人で加速する。
          </h3>
          <p
            className={classnames('company-hero-text', {
              'is-active': isHeroActive,
            })}
          >
            若者や既存の枠を超える「人」の力によって、旧態依然としたファッション業界の変革を促進し、「業界に従事する人」や「ファッションを楽しむ人」の生活を豊かにすることを目指します。
          </p>
          <p
            className={classnames('company-hero-text', {
              'is-active': isHeroActive,
            })}
          >
            そのために、私たちはファッション業界のコミュニケーションにおける課題を解決し、多様な人材がファッション業界で活躍する機会を創出します。
          </p>
          <p
            className={classnames('company-hero-text', {
              'is-active': isHeroActive,
            })}
          >
            また、未来においてあるべき業界像を構想し、ファッション業界に対する新たな価値を提案し続けます。
          </p>
          <div
            className={classnames('company-hero-icon', {
              'is-active': isHeroActive,
            })}
          >
            <a
              className="company-hero-icon-inner"
              onClick={onClickScroll}
            >
              <span></span>
              <span></span>
              <span></span>
            </a>
          </div>
        </div>
        <div
          className={classnames('company-hero-logo', {
            'is-active': isHeroActive,
          })}
        >
          <img
            src={heroLogo}
            width="120"
            height="50"
            alt="READY TO FASHION"
          />
        </div>
      </section>

      {/* OUR SERVICE */}
      <section className="company-service">
        <h2 className="company-info-headtitle">OUR SERVICE</h2>
        <div className="company-service-inner">
          <div className="company-service-contents">
            <a href={rootUrl} target="_blank" rel="noreferrer" className="company-service-link">
              <div className="company-service-imgbox">
                <img src={service1Image} alt="READY TO FASHION" />
              </div>
              <div className="company-service-textbox">
                <h3 className="company-service-title">READY TO FASHION</h3>
                <p className="company-service-title-sub">web</p>
                <p className="company-service-text">
                  ファッション業界のしごとSNS。インスタや業界ならではのスキルを登録して、仕事を探すことができる求人プラットフォーム。
                </p>
              </div>
            </a>
          </div>

          <div className="company-service-contents">
            <a
              href={`${rootUrl}mag/`}
              target="_blank"
              rel="noreferrer"
              className="company-service-link"
            >
              <div className="company-service-imgbox">
                <img src={service2Image} alt="READY TO FASHION" />
              </div>
              <div className="company-service-textbox">
                <h3 className="company-service-title">READY TO FASHION MAG</h3>
                <p className="company-service-title-sub">web</p>
                <p className="company-service-text">
                  ファッション業界に興味のある若者に向けて、ニュースやイベント/採用情報を掲載するメディア。
                </p>
              </div>
            </a>
          </div>

          <div className="company-service-contents">
            <a
              href={`${rootUrl}mag/fashioncommunity1_0.html`}
              target="_blank"
              rel="noreferrer"
              className="company-service-link"
            >
              <div className="company-service-imgbox">
                <img src={service3Image} alt="READY TO FASHION" />
              </div>
              <div className="company-service-textbox">
                <h3 className="company-service-title">fashion community 1.0</h3>
                <p className="company-service-title-sub">community</p>
                <p className="company-service-text">
                  関東・関西に存在する、20以上のファッションサークル(学生団体)によるリアルコミュニティー。
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* NEWS */}
      <section className="company-pastresults">
        <div className="company-pastresults-container">
          <h2 className="company-info-headtitle">NEWS</h2>
          <div className="company-pastresults-list l-grid l-grid-col4">
            <ul className="company-pastresults-list-inner l-grid-inner">
              <li className="company-pastresults-list-item l-grid-item">
                <a
                  className="company-pastresults-link"
                  href="https://www.fashionsnap.com/article/2024-12-04/ready-to-fashion-open-day/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <article className="pastresult-card">
                    <div className="pastresult-card-img">
                      <img src={news1Image} alt="NEWSカテゴリの2枚目の画像" />
                    </div>
                    <p className="pastresult-card-time">December, 2024</p>
                    <h3 className="pastresult-card-heading">
                      アパレル業界の合同マッチングイベント「OPEN DAY」が開催、11社の採用担当とのカジュアルな会話の機会を提供
                    </h3>
                  </article>
                </a>
              </li>

              <li className="company-pastresults-list-item l-grid-item">
                <a
                  className="company-pastresults-link"
                  href="https://jinji.readytofashion.jp/case/interview-clarks"
                  target="_blank"
                  rel="noreferrer"
                >
                  <article className="pastresult-card">
                    <div className="pastresult-card-img">
                      <img src={news2Image} alt="NEWSカテゴリの3枚目の画像" />
                    </div>
                    <p className="pastresult-card-time">December, 2024</p>
                    <h3 className="pastresult-card-heading">
                      【導入インタビュー】クラークスジャパン株式会社が販売員・店長で計6名採用
                    </h3>
                  </article>
                </a>
              </li>

              <li className="company-pastresults-list-item l-grid-item">
                <a
                  className="company-pastresults-link"
                  href={`${rootUrl}mag/report/readytofashion-offline08-report/`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <article className="pastresult-card">
                    <div className="pastresult-card-img">
                      <img src={news3Image} alt="NEWSカテゴリの1枚目の画像" />
                    </div>
                    <p className="pastresult-card-time">February, 2024</p>
                    <h3 className="pastresult-card-heading">
                      【25卒】川上から川下までアパレル30社が集結！アパレル業界特化の新卒向け合同説明会を開催
                    </h3>
                  </article>
                </a>
              </li>

              <li className="company-pastresults-list-item l-grid-item">
                <a
                  className="company-pastresults-link"
                  href="https://prtimes.jp/main/html/rd/p/000000042.000023467.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <article className="pastresult-card">
                    <div className="pastresult-card-img">
                      <img
                        src={news4Image}
                        alt="NEWSカテゴリの4枚目の画像"
                        className="pastresulet-card-img-display"
                      />
                    </div>
                    <p className="pastresult-card-time">May, 2025</p>
                    <h3 className="pastresult-card-heading">
                      新たな広告のメインビジュアルに「TEPPEI」、「三條場夏海」、「柳瀬美央」を起用
                    </h3>
                  </article>
                </a>
              </li>
            </ul>
          </div>
          <p className="company-pastresults-button">
            <a
              href="https://prtimes.jp/main/html/searchrlp/company_id/23467"
              className="company-pastresults-all"
              target="_blank"
              rel="noreferrer"
            >
              VIEW ALL
            </a>
          </p>
        </div>
      </section>

      {/* ABOUT */}
      <section className="company-info" ref={infoRef}>
        <h2 className="company-info-headtitle">ABOUT</h2>
        <div className="u-clear company-info-inner">
          <div className="company-info-right">
            <h3 className="company-info-heading">INFORMATION</h3>
            <ul className="company-info-content">
              <li className="company-info-text">株式会社 READY TO FASHION</li>
              <li className="company-info-text">〒107-0052</li>
              <li className="company-info-text">
                東京都港区赤坂8-5-27 住友不動産青山ビル 東館2F
              </li>
              <li className="company-info-text">2016年11月設立</li>
            </ul>
          </div>
          <div className="company-info-left">
            <h3 className="company-info-heading">BUSINESS AREA</h3>
            <ul className="company-info-content">
              <li className="company-info-text">
                WEBサービスの開発、デザイン及び運用
              </li>
              <li className="company-info-text">メディア、広告事業</li>
              <li className="company-info-text">サービスの営業代行業務</li>
              <li className="company-info-text">
                有料職業紹介事業（厚生労働大臣許可番号13-ユ-310817）
              </li>
            </ul>
          </div>
        </div>

        <div className="u-clear company-info-inner">
          <div className="company-info-left">
            <h3 className="company-info-heading">BOARD MEMBER</h3>
            <ul className="company-info-content">
              <li className="company-info-text">代表取締役{'\u3000'}｜{'\u3000'}高野 聡司</li>
              <li className="company-info-text">監査役{'\u3000'}｜{'\u3000'}中村 和弘</li>
              <li className="company-info-text">監査役{'\u3000'}｜{'\u3000'}高橋 剛</li>
            </ul>
          </div>
        </div>
      </section>

      {/* RECRUIT */}
      <section className="company-adopt">
        <h2 className="company-info-headtitle">RECRUIT</h2>
        <p className="company-adopt-text">
          採用情報はこちらからご覧ください。
        </p>
        <p className="company-adopt-button">
          <a
            href={`${rootUrl}companies/25`}
            className="company-adopt-link"
            target="_blank"
            rel="noreferrer"
          >
            RECRUIT
          </a>
        </p>
      </section>

      {/* CONTACT */}
      <section className="company-contact">
        <h2 className="company-info-headtitle">CONTACT</h2>
        <p className="company-contact-text">
          お問い合わせはこちらからお願いします。
        </p>
        <p className="company-contact-button">
          <a
            href={contactIndexUrl}
            className="company-contact-link"
            target="_blank"
            rel="noreferrer"
          >
            CONTACT
          </a>
        </p>
      </section>
    </main>
  );
};
